import { exportHistory } from './ExportHistory/ExportHistory.i18n.ja'

export const attendanceLogs = {
  title: 'マッチングデータ',
  exportHistory,
}
